import * as React from "react";
import FAQsAccordion from "../../FAQsAccordion/index";
import { FAQsAccordionType } from "../../types/FAQsAccordion";
import { marketingCtaClicked } from "@utils/segment/marketingCtaClicked";
import { Builder } from "@builder.io/react";

const FAQsAccordionWrapper: React.FC<FAQsAccordionType> = ({
  headline,
  ctaCopy,
  ctaLink,
  ctaUrl,
  faqs,
}) => {
  const onClick: React.MouseEventHandler<HTMLAnchorElement> = () => {
    marketingCtaClicked({
      text: ctaCopy,
      url: window.location.pathname,
      target: ctaLink?.value?.data?.url || ctaUrl,
    });
  };

  return (
    <FAQsAccordion
      headline={headline}
      ctaCopy={ctaCopy}
      ctaLink={ctaLink}
      ctaUrl={ctaUrl}
      faqs={faqs}
      onClick={onClick}
    />
  );
};

export default FAQsAccordionWrapper;

export const RegisterFAQsAccordion = () => {
  Builder.registerComponent(FAQsAccordionWrapper, {
    name: "faqs",
    inputs: [
      {
        name: "headline",
        type: "text",
      },
      { name: "ctaCopy", type: "text" },
      { name: "ctaLink", type: "reference", model: "page" },
      { name: "ctaUrl", type: "text" },
      {
        name: "faqs",
        type: "list",
        subFields: [
          {
            name: "faq",
            type: "reference",
            model: "faq",
          },
        ],
      },
    ],
  });
};
